module.exports = __webpack_public_path__ + "assets/img/block-left-hover-4fe2ba58.png";